import { render, staticRenderFns } from "./SingleItemSetComponent.vue?vue&type=template&id=014d5eb0&"
import script from "./SingleItemSetComponent.vue?vue&type=script&lang=js&"
export * from "./SingleItemSetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/22413/203/Snaply5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('014d5eb0')) {
      api.createRecord('014d5eb0', component.options)
    } else {
      api.reload('014d5eb0', component.options)
    }
    module.hot.accept("./SingleItemSetComponent.vue?vue&type=template&id=014d5eb0&", function () {
      api.rerender('014d5eb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/SingleItemSetComponent.vue"
export default component.exports